<template>
  <el-form
    :inline="true"
    :model="form"
    label-width="100px"
    class="demo-ruleForm"
  >
    <el-form-item v-for="item in formLabel" :key="item.model" :label="item.label">
      <el-input
        v-if="!item.type"
        v-model="form[item.model]"
        :placeholder="'请输入' + item.label"
      ></el-input>

      <el-checkbox-group
        v-if="item.type === 'checkbox'"
        v-model="form[item.model]"
        style="text-align: left  ; padding-left: 0.2rem">
        <el-checkbox
          v-for="boxItem in item.boxItems"
          :key="boxItem.value"
          :label="boxItem.label"
          :value="boxItem.value"
          style="width: 0.7rem ; text-align: left ; margin-left: 0"
          border>
          {{ boxItem.text }}
        </el-checkbox>
      </el-checkbox-group>

      <el-select
        v-if="item.type === 'select'"
        v-model="form[item.model]"
        placeholder="请选择"
      >
        <el-option
          v-for="optionitem in item.opts"
          :key="optionitem.value"
          :label="optionitem.label"
          :value="optionitem.value"
        ></el-option>
      </el-select>
      <el-switch
        v-if="item.type === 'switch'"
        v-model="form[item.model]"
      ></el-switch>
      <el-date-picker
        v-if="item.type === 'date'"
        v-model="form[item.model]"
        type="date"
        placeholder="选择日期时间"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item>
      <slot></slot>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'CommonForm',
  props: {
    inline: Boolean,
    form: Object,
    formLabel: Array
  }
}
</script>

<style scoped>

</style>
